import mixpanel from 'mixpanel-browser';
import env from 'environment';

const {
  PLATFORM_URL,
  MIXPANEL_TOKEN,
  MIXPANEL_API_HOST,
} = env;

const getBaseProperties = () => {
  if (window.mixpanelProperties) {
    return window.mixpanelProperties;
  }
  if (!window.mpPP) {
    const loadMixpanelProperties = async () => {
      const response = await fetch(`${PLATFORM_URL}/front_api/mixpanel/data`, {
        credentials: 'include',
      });
      return response.json();
    };
    window.mpPP = loadMixpanelProperties();
  }
  return window.mpPP;
};

const mixpanelProxy = new Proxy({
  mixpanel,
  shouldTrack: false,
  async init() {
    if (!this.initPromise) {
      this.initPromise = (async () => {
        const { mixpanel } = this;
        const properties = await getBaseProperties();
        mixpanel.init(MIXPANEL_TOKEN, { api_host: MIXPANEL_API_HOST, debug: true });
        this.shouldTrack = properties.should_track;
        if (this.shouldTrack) {
          const {
            user_id: userId,
            session_id: sessionId,
            current_package: currentPackage,
          } = properties;

          mixpanel.identify(userId);

          mixpanel.register({
            session_id: sessionId,
            current_package: currentPackage,
          });
        }
      })();
    }
    return this.initPromise;
  },
}, {
  get(target, prop) {
    if (typeof target.mixpanel[prop] === 'function') {
      return async (...args) => {
        await target.init();

        if (!target.shouldTrack) {
          return false;
        }

        return target.mixpanel[prop](...args);
      };
    }
    return target.mixpanel[prop];
  },
});

mixpanelProxy.init();
export default mixpanelProxy;



// WEBPACK FOOTER //
// ./app/utils/mixpanel/mixpanel.js